import { IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { ICircleSelectObject } from "../../../../../domain/editableFormat/objects";
import { ICircleSelectObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { LineStyleTranslator, PatientProfileCheckKindTranslator } from "./properties";
import { CheckableObjectTranslator } from "./base";

export class CircleSelectObjectTranslator extends AbstractObjectTranslator<ICircleSelectObject, ICircleSelectObjectBean> {
  constructor() {
    super(new CheckableObjectTranslator());
  }

  protected shouldRecordName(source: ICircleSelectObjectBean): boolean {
    return true;
  }

  protected readName(source: ICircleSelectObjectBean): IObjectNameIdentifier {
    return {
      key: source["@name"],
      subKey: source["@item-name"],
    };
  }

  overwriteObject(source: ICircleSelectObject, bean: ICircleSelectObjectBean, formatId: number): void {
    const on = (bean["@score-on"] !== undefined)
      ? this.integer.from(bean["@score-on"])
      : undefined;
    const isScoreOn = !!on && !isNaN(on);
    const off = (bean["@score-off"] !== undefined)
      ? this.integer.from(bean["@score-off"])
      : undefined;
    const isScoreOff = !!off && !isNaN(off);
    source.checkBehavior = {
      isChecked: (bean["@selected"] === "1"),
      isMultiCheckable: (bean["@select-mode"] === "2"),
      score: {
        on: isScoreOn ? on : 0,
        off: isScoreOff ? off : 0,
      },
      patientProfileKinds: this.patientProfileCheckKind.from(bean["@ptprofile-option"]),
      pastedTextToCheck: bean["@text"],
      isGroupScopePage: (bean["@group-scope"] !== "1"),
    };
    source.lineStyle = this.lineStyle.from(bean);
    const copies = (bean["@copies-selected"] !== undefined)
      ? this.integer.from(bean["@copies-selected"])
      : undefined;
    const isCopiesLineBehaviorEnable = !!copies && !isNaN(copies);
    source.copyLinkedCheckBehavior = {
      isEnable: isCopiesLineBehaviorEnable,
      no: isCopiesLineBehaviorEnable ? copies : 1, 
    };
  }

  overwriteBean(source: ICircleSelectObjectBean, object: ICircleSelectObject): void {
    source["@selected"] = object.checkBehavior.isChecked ? "1" : "0";
    source["@select-mode"] = object.checkBehavior.isMultiCheckable ? "2" : undefined;
    source["@score-on"] = object.checkBehavior.score.on !== 0 ? this.integer.to(object.checkBehavior.score.on) : undefined;
    source["@score-off"] = object.checkBehavior.score.off !== 0 ? this.integer.to(object.checkBehavior.score.off) : undefined;
    source["@ptprofile-option"] = this.patientProfileCheckKind.to(object.checkBehavior.patientProfileKinds);
    source["@text"] = object.checkBehavior.pastedTextToCheck;
    source["@group-scope"] = object.checkBehavior.isGroupScopePage ? undefined : "1";
    source["@type"] = this.lineStyle.to(object).type;
    source["@color"] = this.lineStyle.to(object).color;
    source["@border-width"] = this.lineStyle.to(object).borderWidth;
    source["@copies-selected"] = object.copyLinkedCheckBehavior.isEnable
      ? this.integer.to(object.copyLinkedCheckBehavior.no)
      : undefined;
  }

  private readonly lineStyle = new LineStyleTranslator();
  private readonly patientProfileCheckKind = new PatientProfileCheckKindTranslator();
}
